module.exports = __webpack_public_path__ + "img/ergo.109f0af4.png";